import React from "react";
import { getSecureFileUrl } from "../../../utils/secureFileHelper";

const CommunicationMessage = ({ message, adminUid }) => {

    const isAdmin = message?.sender == adminUid;

    

    const renderMessage = () => {

    switch (message?.message_type) {

        case "image":

            return (

                <a
                    href={message?.file_url}
                    target="_blank"
                    rel="noopener noreferrer"
                >

                    <img
                        src={message?.file_url}
                        alt="attachment"
                        className="max-w-[260px] rounded-lg border cursor-pointer hover:opacity-90 transition"
                    />

                    

                </a>

            );

        case "pdf":

            return (

                <a
                    href={getSecureFileUrl(message?.file_url, 'pdf')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 border rounded-lg p-3"
                >

                    <span className="text-3xl">
                        📄
                    </span>

                    <div>

                        <p className="font-medium">
                            PDF Document
                        </p>

                        <p className="text-sm underline">
                            Open PDF
                        </p>

                    </div>

                </a>

            );

        case "video":

            return (

                <div>

                    <video
                        controls
                        className="max-w-[260px] rounded-lg"
                    >

                        <source src={message?.file_url} />

                    </video>

                    <a
                        href={message?.file_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-xs underline mt-2 block"
                    >
                        Open in new tab
                    </a>

                </div>

            );

        case "file":

            return (

                <a
                    href={message?.file_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    download
                    className="flex items-center gap-3 border rounded-lg p-3 hover:bg-gray-100"
                >

                    <span className="text-3xl">
                        📎
                    </span>

                    <div>

                        <p className="font-medium">
                            Attachment
                        </p>

                        <p className="text-sm underline">
                            Download
                        </p>

                    </div>

                </a>

            );

        case "link":

            return (

                <a
                    href={message?.message}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline break-all"
                >
                    {message?.message}
                </a>

            );

        default:

            return (

                <p className="whitespace-pre-wrap break-words">

                    {message?.message}

                </p>

            );

    }

};

    return (

        <div
            className={`flex mb-4 ${
                isAdmin
                    ? "justify-end"
                    : "justify-start"
            }`}
        >

            <div
                className={`max-w-[70%] rounded-2xl shadow px-4 py-3 ${
                    isAdmin
                        ? "bg-blue-600 text-white"
                        : "bg-white border text-gray-800"
                }`}
            >

                {renderMessage()}

                <div
                    className={`text-[11px] mt-3 text-right ${
                        isAdmin
                            ? "text-blue-100"
                            : "text-gray-400"
                    }`}
                >

                    {message?.created_date}

                </div>

            </div>

        </div>

    );

};

export default CommunicationMessage;